// src/components/InstallBanner.js
import React, { useState, useEffect } from 'react';

const InstallBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if mobile device
    const mobileCheck = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    
    setIsMobile(mobileCheck);
    
    // Show banner only on mobile and not in standalone mode (already installed)
    if (mobileCheck && !isStandalone) {
      // Check if user dismissed banner before
      const bannerDismissed = localStorage.getItem('kohlaBannerDismissed');
      if (!bannerDismissed) {
        setShowBanner(true);
      }
    }
  }, []);

  const handleInstall = () => {
    // For Android - trigger APK download
    const apkUrl = '/apk/kohla-news.apk';
    window.open(apkUrl, '_blank');
    
    // Track installation attempt
    localStorage.setItem('kohlaInstallAttempted', 'true');
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('kohlaBannerDismissed', 'true');
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Mobile Bottom Banner */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#1a237e',
        color: 'white',
        padding: '12px 16px',
        zIndex: 9999,
        boxShadow: '0 -4px 20px rgba(0,0,0,0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        animation: 'slideUp 0.5s ease-out',
        borderTop: '3px solid #ffc107'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
          <div style={{
            backgroundColor: '#ffc107',
            borderRadius: '50%',
            width: '44px',
            height: '44px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
            flexShrink: 0
          }}>
            📱
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 'bold', fontSize: '15px' }}>
              Kohla News App
            </div>
            <div style={{ fontSize: '12px', opacity: 0.8 }}>
              Get breaking news instantly
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <button
            onClick={handleInstall}
            style={{
              backgroundColor: '#ffc107',
              color: '#1a237e',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '20px',
              fontWeight: 'bold',
              fontSize: '13px',
              cursor: 'pointer',
              whiteSpace: 'nowrap'
            }}
          >
            Install 📥
          </button>
          <button
            onClick={handleDismiss}
            style={{
              background: 'transparent',
              border: 'none',
              color: 'rgba(255,255,255,0.6)',
              fontSize: '20px',
              cursor: 'pointer',
              padding: '4px 8px'
            }}
          >
            ✕
          </button>
        </div>
      </div>

      {/* Full Screen Popup for First Visit */}
      {!localStorage.getItem('kohlaPopupShown') && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 99999,
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '20px',
            padding: '32px 24px',
            maxWidth: '400px',
            width: '100%',
            textAlign: 'center',
            animation: 'popIn 0.4s ease-out'
          }}>
            <div style={{ fontSize: '72px', marginBottom: '12px' }}>📰</div>
            <h2 style={{ 
              color: '#1a237e', 
              fontSize: '22px',
              marginBottom: '8px',
              fontWeight: 'bold'
            }}>
              Get Kohla News App
            </h2>
            <p style={{ 
              color: '#666', 
              fontSize: '15px',
              marginBottom: '20px',
              lineHeight: '1.5'
            }}>
              Breaking news from Okara, Punjab, and Pakistan — right on your phone!
            </p>
            
            <div style={{ 
              backgroundColor: '#f5f5f5', 
              borderRadius: '12px',
              padding: '16px',
              marginBottom: '20px',
              textAlign: 'left'
            }}>
              <div style={{ display: 'flex', gap: '12px', marginBottom: '10px' }}>
                <span>⚡</span>
                <span style={{ fontSize: '14px' }}>Instant breaking news alerts</span>
              </div>
              <div style={{ display: 'flex', gap: '12px', marginBottom: '10px' }}>
                <span>📺</span>
                <span style={{ fontSize: '14px' }}>Live video coverage</span>
              </div>
              <div style={{ display: 'flex', gap: '12px' }}>
                <span>📱</span>
                <span style={{ fontSize: '14px' }}>Optimized for mobile</span>
              </div>
            </div>

            <button
              onClick={() => {
                handleInstall();
                localStorage.setItem('kohlaPopupShown', 'true');
              }}
              style={{
                backgroundColor: '#1a237e',
                color: 'white',
                border: 'none',
                padding: '14px 32px',
                borderRadius: '12px',
                fontWeight: 'bold',
                fontSize: '17px',
                cursor: 'pointer',
                width: '100%',
                marginBottom: '12px'
              }}
            >
              📥 Download APK
            </button>
            
            <button
              onClick={() => {
                localStorage.setItem('kohlaPopupShown', 'true');
                const popup = document.querySelector('[style*="z-index: 99999"]');
                if (popup) popup.style.display = 'none';
              }}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#999',
                fontSize: '14px',
                cursor: 'pointer'
              }}
            >
              Continue to website
            </button>
          </div>
        </div>
      )}

      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes popIn {
          from { transform: scale(0.8); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </>
  );
};

export default InstallBanner;